export default "__VITE_ASSET__BYatlzdB__"